import Vue from 'vue'
import Page from './Page'
import Svg from './Svg'
import Cbutton from './Cbutton'
import Pagination from './Pagination.vue'
import SelectCustomer from './SelectCustomer.vue'

const CommonComponents = [Page, Pagination, Svg, Cbutton, SelectCustomer]

export default CommonComponents.map(Component => {
  return () => {
    if (!Component.name) {
      console.error('组件未设置name属性，无法注册为全局组件', Component)
    } else {
      return Vue.component(Component.name, Component)
    }
  }
})
